import TagsForm from './TagsForm';

export default TagsForm;
